/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Fine_PrintInputs */

const en_directory_ai_tools_studio_fine_print = /** @type {(inputs: Directory_Ai_Tools_Studio_Fine_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time credit packs · Failed renders are refunded · Ready in a few minutes`)
};

const zh_directory_ai_tools_studio_fine_print = /** @type {(inputs: Directory_Ai_Tools_Studio_Fine_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性积分包 · 生成失败自动退还 · 几分钟出片`)
};

/**
* | output |
* | --- |
* | "One-time credit packs · Failed renders are refunded · Ready in a few minutes" |
*
* @param {Directory_Ai_Tools_Studio_Fine_PrintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_fine_print = /** @type {((inputs?: Directory_Ai_Tools_Studio_Fine_PrintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Fine_PrintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_fine_print(inputs)
	return zh_directory_ai_tools_studio_fine_print(inputs)
});
export { directory_ai_tools_studio_fine_print as "directory.ai_tools.studio.fine_print" }